var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { ARIAL_FONT, LIBERATION_MONO_FONT, LIBERATION_SANS_FONT, LIBERATION_SERIF_FONT } from "pxc-editor-material-svg-rendering/constants";
import ArialRegular from "../../assets/fonts/ArialOS/arial.woff2";
import ArialBold from "../../assets/fonts/ArialOS/arialbd.woff2";
import ArialBoldItalic from "../../assets/fonts/ArialOS/arialbi.woff2";
import ArialItalic from "../../assets/fonts/ArialOS/ariali.woff2";
import LiberationSansRegular from "../../assets/fonts/libsans/LiberationSans-Regular.woff2";
import LiberationSansBold from "../../assets/fonts/libsans/LiberationSans-Bold.woff2";
import LiberationSansBoldItalic from "../../assets/fonts/libsans/LiberationSans-BoldItalic.woff2";
import LiberationSansItalic from "../../assets/fonts/libsans/LiberationSans-Italic.woff2";
import LiberationSerifRegular from "../../assets/fonts/libserif/LiberationSerif-Regular.woff2";
import LiberationSerifBold from "../../assets/fonts/libserif/LiberationSerif-Bold.woff2";
import LiberationSerifBoldItalic from "../../assets/fonts/libserif/LiberationSerif-BoldItalic.woff2";
import LiberationSerifItalic from "../../assets/fonts/libserif/LiberationSerif-Italic.woff2";
import LiberationMonoRegular from "../../assets/fonts/libmono/LiberationMono-Regular.woff2";
import LiberationMonoBold from "../../assets/fonts/libmono/LiberationMono-Bold.woff2";
import LiberationMonoBoldItalic from "../../assets/fonts/libmono/LiberationMono-BoldItalic.woff2";
import LiberationMonoItalic from "../../assets/fonts/libmono/LiberationMono-Italic.woff2";
export var fontFormat = "woff2";
export function makeFontKey(name, bold, italic) {
    return "".concat(name.replace(/\s/g, "_"), "_").concat(bold ? "bold" : "normal", "_").concat(italic ? "italic" : "normal");
}
function makeFontRecord(map, name, bold, italic, url) {
    var key = makeFontKey(name, bold, italic);
    var value = { name: name, url: url, bold: bold, italic: italic };
    if (map[key]) {
        console.warn("FontDescriptor already exists for ".concat(key, ": old value = {").concat(JSON.stringify(map[key]), "}; new value = {").concat(value));
    }
    // eslint-disable-next-line no-param-reassign
    map[key] = value;
    return [key, value];
}
var InitFontsMap = function () {
    var map = {};
    makeFontRecord(map, ARIAL_FONT, false, false, ArialRegular);
    makeFontRecord(map, ARIAL_FONT, true, false, ArialBold);
    makeFontRecord(map, ARIAL_FONT, true, true, ArialBoldItalic);
    makeFontRecord(map, ARIAL_FONT, false, true, ArialItalic);
    makeFontRecord(map, LIBERATION_SANS_FONT, false, false, LiberationSansRegular);
    makeFontRecord(map, LIBERATION_SANS_FONT, true, false, LiberationSansBold);
    makeFontRecord(map, LIBERATION_SANS_FONT, true, true, LiberationSansBoldItalic);
    makeFontRecord(map, LIBERATION_SANS_FONT, false, true, LiberationSansItalic);
    makeFontRecord(map, LIBERATION_SERIF_FONT, false, false, LiberationSerifRegular);
    makeFontRecord(map, LIBERATION_SERIF_FONT, true, false, LiberationSerifBold);
    makeFontRecord(map, LIBERATION_SERIF_FONT, true, true, LiberationSerifBoldItalic);
    makeFontRecord(map, LIBERATION_SERIF_FONT, false, true, LiberationSerifItalic);
    makeFontRecord(map, LIBERATION_MONO_FONT, false, false, LiberationMonoRegular);
    makeFontRecord(map, LIBERATION_MONO_FONT, true, false, LiberationMonoBold);
    makeFontRecord(map, LIBERATION_MONO_FONT, true, true, LiberationMonoBoldItalic);
    makeFontRecord(map, LIBERATION_MONO_FONT, false, true, LiberationMonoItalic);
    return map;
};
var fontsMap = InitFontsMap();
export function findFontRecord(key) {
    return fontsMap[key];
}
function cacheFontBase64(key, base64) {
    if (fontsMap[key]) {
        if (fontsMap[key].base64) {
            console.warn("Font for key ".concat(key, " already has a base64 set."));
        }
        fontsMap[key].base64 = base64;
        return true;
    }
    console.error("Font not found for key ".concat(key, "."));
    return false;
}
function patchFontDataUrlMimeType(input) {
    return input.replace("data:application/octet-stream;", "data:font/".concat(fontFormat, ";"));
}
function loadFontIntoDataUriXhr(key, url) {
    return new Promise(function (resolve, reject) {
        try {
            var xhr_1 = new XMLHttpRequest();
            xhr_1.onreadystatechange = function () {
                if (xhr_1.readyState === 4) {
                    if (xhr_1.status === 200) {
                        var f_1 = new FileReader();
                        f_1.onload = function () {
                            if (f_1.result) {
                                if (f_1.result instanceof ArrayBuffer) {
                                    var dec = new TextDecoder();
                                    cacheFontBase64(key, patchFontDataUrlMimeType(dec.decode(f_1.result)));
                                    resolve();
                                }
                                else {
                                    cacheFontBase64(key, patchFontDataUrlMimeType(f_1.result));
                                    resolve();
                                }
                            }
                            reject();
                        };
                        f_1.onerror = function () {
                            reject();
                        };
                        f_1.readAsDataURL(xhr_1.response);
                    }
                    else {
                        reject(xhr_1.statusText);
                    }
                }
            };
            xhr_1.open("GET", url);
            xhr_1.responseType = "blob";
            xhr_1.send();
        }
        catch (e) {
            reject(e);
        }
    });
}
function loadFontIntoDataUriFetch(key, url) {
    return new Promise(function (resolve, reject) {
        fetch(url)
            .then(function (resp) { return resp.blob(); })
            .then(function (blob) {
            var f = new FileReader();
            f.onload = function () {
                if (f.result) {
                    if (f.result instanceof ArrayBuffer) {
                        var dec = new TextDecoder();
                        cacheFontBase64(key, patchFontDataUrlMimeType(dec.decode(f.result)));
                        resolve();
                    }
                    else {
                        cacheFontBase64(key, patchFontDataUrlMimeType(f.result));
                        resolve();
                    }
                }
                reject();
            };
            f.onerror = reject;
            f.readAsDataURL(blob);
        })
            .catch(function (e) { return reject(e); });
    });
}
function loadFontIntoDataUri(key, url) {
    return loadFontIntoDataUriFetch(key, url);
}
export function PreloadAllFontsBase64() {
    var ret = [];
    Object.keys(fontsMap)
        .map(function (key) {
        var fd = fontsMap[key];
        if (!fd.base64) {
            return loadFontIntoDataUri(key, fd.url);
        }
        return null;
    })
        .forEach(function (promise) {
        if (promise) {
            ret.push(promise);
        }
    });
    return Promise.all(ret);
}
export var FontsLoaderEmbedded = function (_a) {
    var list = _a.list;
    return (React.createElement("style", { type: "text/css" }, Object.keys(list).map(function (key) {
        var _a = list[key], name = _a.name, bold = _a.bold, italic = _a.italic, base64 = _a.base64;
        if (!base64) {
            console.error("base64 not set for font ".concat(JSON.stringify(list[key])));
        }
        return "\n          @font-face {\n            font-family: '".concat(name, "';\n            font-weight: ").concat(bold ? 'bold' : 'normal', ";\n            font-style: ").concat(italic ? 'italic' : 'normal', ";\n            src: url(").concat(base64, ") format('").concat(fontFormat, "');\n          }\n        ");
    })));
};
var FontsLoader = function () {
    return (React.createElement("style", { type: "text/css" }, Object.entries(fontsMap).map(function (entry) {
        var _a = entry[1], name = _a.name, url = _a.url, base64 = _a.base64, bold = _a.bold, italic = _a.italic;
        return "\n          @font-face {\n            font-family: '".concat(name, "';\n            font-weight: ").concat(bold ? "bold" : "normal", ";\n            font-style: ").concat(italic ? "italic" : "normal", ";\n            src: url(").concat(base64 || url, ") format('").concat(fontFormat, "');\n          }\n        ");
    })));
};
export default React.memo(FontsLoader);
export var preloadMaterialTextFonts = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.all([
                new FontFace(ARIAL_FONT, "url(".concat(ArialRegular, ")"), { style: 'normal', weight: 'normal' }).load(),
                new FontFace(ARIAL_FONT, "url(".concat(ArialBold, ")"), { style: 'normal', weight: 'bold' }).load(),
                new FontFace(ARIAL_FONT, "url(".concat(ArialBoldItalic, ")"), { style: 'italic', weight: 'bold' }).load(),
                new FontFace(ARIAL_FONT, "url(".concat(ArialItalic, ")"), { style: 'italic', weight: 'normal' }).load(),
                new FontFace(LIBERATION_SANS_FONT, "url(".concat(LiberationSansRegular, ")"), { style: 'normal', weight: 'normal' }).load(),
                new FontFace(LIBERATION_SANS_FONT, "url(".concat(LiberationSansBold, ")"), { style: 'normal', weight: 'bold' }).load(),
                new FontFace(LIBERATION_SANS_FONT, "url(".concat(LiberationSansBoldItalic, ")"), { style: 'italic', weight: 'bold' }).load(),
                new FontFace(LIBERATION_SANS_FONT, "url(".concat(LiberationSansItalic, ")"), { style: 'italic', weight: 'normal' }).load(),
                new FontFace(LIBERATION_SERIF_FONT, "url(".concat(LiberationSerifRegular, ")"), { style: 'normal', weight: 'normal' }).load(),
                new FontFace(LIBERATION_SERIF_FONT, "url(".concat(LiberationSerifBold, ")"), { style: 'normal', weight: 'bold' }).load(),
                new FontFace(LIBERATION_SERIF_FONT, "url(".concat(LiberationSerifBoldItalic, ")"), { style: 'italic', weight: 'bold' }).load(),
                new FontFace(LIBERATION_SERIF_FONT, "url(".concat(LiberationSerifItalic, ")"), { style: 'italic', weight: 'normal' }).load(),
                new FontFace(LIBERATION_MONO_FONT, "url(".concat(LiberationMonoRegular, ")"), { style: 'normal', weight: 'normal' }).load(),
                new FontFace(LIBERATION_MONO_FONT, "url(".concat(LiberationMonoBold, ")"), { style: 'normal', weight: 'bold' }).load(),
                new FontFace(LIBERATION_MONO_FONT, "url(".concat(LiberationMonoBoldItalic, ")"), { style: 'italic', weight: 'bold' }).load(),
                new FontFace(LIBERATION_MONO_FONT, "url(".concat(LiberationMonoItalic, ")"), { style: 'italic', weight: 'normal' }).load(),
            ]).then(function (fonts) {
                fonts.forEach(function (item) { return document.fonts.add(item); });
            }).catch(function (error) {
                console.error("Failed to load fonts");
            })];
    });
}); };
